(ns frontend.view.settings.sys-admin.db
  (:require [frontend.db :as db]
            [common.util :as cu]
            [reagent.core :as r]
            [reagent.ratom :as ratom]))

(defonce sys-admin (r/cursor db/app-state [:views :settings :sys-admin]))
(defonce tenant (r/cursor sys-admin [:tenant]))
(defonce tenant-data (r/cursor sys-admin [:tenant-data]))
(defonce new-holding (r/cursor sys-admin [:new-holding]))
(defonce new-holding-state (r/cursor sys-admin [:new-holding-state]))
(defonce new-holding-info (r/cursor sys-admin [:new-holding-info]))
(defonce modified-plan (r/cursor sys-admin [:modified-plan]))
(defonce plan (r/cursor tenant [:tenant/product-plan]))
(defonce modified-features (r/cursor modified-plan [:features]))

(def cached-reports
  (ratom/reaction
   (->> @tenant-data
        :entities
        vals
        (cu/only-entity :entity.type/cached-report)
        doall)))

(def zadmin-metabase-reports
  (ratom/reaction
   (->> @tenant-data
        :entities
        vals
        (cu/only-entity :entity.type/metabase-dashboard)
        (sort-by :common/ord)
        doall)))
